<app-header></app-header>
<div class="app-body">
    <router-outlet (activate)="onActivate($event)" ></router-outlet>
</div>
<app-footer></app-footer>
